import React from 'react'
import styled from 'styled-components'
import { FormFeedback } from 'reactstrap'
import Text from '../../utils/Text'

const CustomFormFeedback = ({ className, children, id }) => {
  return (
    <FormFeedback id={id} className={className} color="danger">
      {children.map(c => (
        <Text key={c} id={c} />
      ))}
    </FormFeedback>
  )
}

const StyledFormFeedback = styled(CustomFormFeedback)`
  text-align: left;
  color: red;
  margin-top: 10px !important;
  margin-left: 10px;
  display: block !important;
`

const NotError = styled.div`
  height: 26px;
`

export default function ErrorMessage({ error, id }) {
  if (!error) return <NotError />
  return <StyledFormFeedback id={id}>{error}</StyledFormFeedback>
}
